import styled from '@emotion/styled';

import CONST from '../constants';
import imgTitleBG from '../resources/pattern-title.svg';

export const Container = styled.div`
    position: relative;
    top: 0;
    width: 100%;
    min-height: calc(100vh - ${CONST.FOOTER_HEIGHT.MOBILE});
    margin-bottom: ${CONST.FOOTER_HEIGHT.MOBILE} !important;
    background: ${CONST.COLOR.CREAM};
    z-index: 2;

    @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
        min-height: calc(100vh - ${CONST.FOOTER_HEIGHT.STATIC});
        margin-bottom: ${CONST.FOOTER_HEIGHT.STATIC} !important;
    }
`;

export const Body = styled.div`
    position: relative;
    max-width: ${CONST.SCREEN.BREAKPOINT.XL}px;
    padding-bottom: 5vw;
    margin: 0 auto;
    text-align: center;

    @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
        padding-bottom: 3vw;
    }
`;

export const Title = ({ textKr, textEng }) => {
    const Container = styled.div`
        position: relative;
        height: 40vw;
        background: ${CONST.COLOR.BG};
        background-image: url(${imgTitleBG});
        background-position: 0 50px;
        border-top: 0.25vw inset ${CONST.COLOR.THEME_LIGHT}7F;
        border-bottom: 0.5vw outset ${CONST.COLOR.THEME};

        &:first-of-type {
            border-top: none;
        }

        @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
            background-position: initial;
            height: 20vw;
            border-top: 0.1vw inset ${CONST.COLOR.THEME_LIGHT}7F;
            border-bottom: 0.2vw outset ${CONST.COLOR.THEME};
        }

        @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.XL}px) {
            height: ${CONST.SCREEN.BREAKPOINT.XL * 0.2}px;
            border-top: ${CONST.SCREEN.BREAKPOINT.XL * 0.001}px inset ${CONST.COLOR.THEME_LIGHT}7F;
            border-bottom: ${CONST.SCREEN.BREAKPOINT.XL * 0.002}px outset ${CONST.COLOR.THEME};

            &:first-of-type {
                border-top: none;
            }
        }

        & > div {
            position: absolute;
            top: 50%;
            left: 50%;
            text-align: center;
            transform: translate(-50%, -50%);
        }

        & > div > p {
            display: inline-block;
            margin: 0;
            color: ${CONST.COLOR.THEME};
            font-size: 8vw;
            white-space: nowrap;

            @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
                font-size: 5vw;
            }

            @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.XL}px) {
                font-size: ${CONST.SCREEN.BREAKPOINT.XL * 0.05}px;
            }
        }

        & > div > p.eng {
            display: inline-block;
            color: ${CONST.COLOR.THEME};
            font-size: 6vw;
            text-transform: uppercase;

            @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
                font-size: 4.5vw;
            }

            @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.XL}px) {
                font-size: ${CONST.SCREEN.BREAKPOINT.XL * 0.045}px;
            }
        }
    `;

    const TitleDivider = styled(Divider)`
        margin: 3vw auto;

        @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
            margin: 1vw auto;
        }
    `;

    return (
        <Container>
            <div>
                <p>{textKr}</p>
                <TitleDivider />
                <p className="eng">{textEng}</p>
            </div>
        </Container>
    );
};

export const Divider = styled.div`
    height: 0.25vw;
    margin: 0 auto;
    background: ${CONST.COLOR.TEXT};

    @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.MD}px) {
        height: ${CONST.SCREEN.BREAKPOINT.MD * 0.0025}px;
    }
`;
